// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__2ZTDFKuIgdXFBwd3B9HivU","wide":"style-module_wide__w1eR6F47TrhLl7GCk230e","buttons":"style-module_buttons__J0URN532xgKSR0h8fNZFc"};